module.exports = __webpack_public_path__ + "static/media/landin-page-galary.85586c55.webp";